import { observable, action, computed } from 'mobx';
import { Config } from '~domain/entities/Config';
import { IActiveFilters } from '~api/Interfaces';
import { IBooleanFilters } from '~interfaces/IStoresInterfaces';

export class BopisFiltersRepository {
    @observable public booleanFilters: IBooleanFilters = {};
    @observable public openNowEnabled: boolean = false;

    constructor(configService: Config) {
        const config = configService.config;
        const featureFlags = config && config.featureFlags;
        this.openNowEnabled = featureFlags && featureFlags.openNow;
        this.initializeFilters();
    }

    @action
    private initializeFilters = () => {
        if (this.openNowEnabled) {
            this.booleanFilters = {
                ...this.booleanFilters,
                openNow: false,
                storesWithAvailability: false
            };
        }
    };

    @action toggleBooleanFilter = (filterType: string) => {
        this.booleanFilters[filterType] = !this.booleanFilters[filterType];
    };

    @computed
    public get activeFilters(): IActiveFilters {
        return {
            ...this.booleanFilters
        };
    }
}
